import { render, staticRenderFns } from "./LabelSelector.vue?vue&type=template&id=38c0cc9a"
import script from "./LabelSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./LabelSelector.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports